import * as TypeAction from './actionTypes'
import { actionSincCRUD, actionSyncListObj } from 'scorpion-core';
import { listarDinamicCustomForms, salvaObj, listarObjs, salvaObjRaiz, listarObjsRaiz, getHistoricoRaiz } from './api';
import { userUid } from '../../../firebase'

export const listar = () => (dispatch) => {
    listarDinamicCustomForms(actionSyncListObj(TypeAction.LISTAR, dispatch));
}

export const salvar_obj = (customForm, item, retorno) => (dispatch) => {
    item.userLastChange = userUid()
    if (customForm.chaveSalvar) {
        actionSincCRUD(salvaObjRaiz(customForm.chaveSalvar, item), TypeAction.SALVAR_OBJ, dispatch, retorno)
    } else {
        actionSincCRUD(salvaObj(customForm.uid, userUid(), item), TypeAction.SALVAR_OBJ, dispatch, retorno)
    }
}

export const listar_obj = (customForm) => (dispatch) => {
    if (customForm.chaveSalvar) {
        listarObjsRaiz(customForm.chaveSalvar, actionSyncListObj(TypeAction.LISTAR_OBJ, dispatch, null, customForm.chaveSalvar));
    } else {
        listarObjs(customForm.uid, userUid(), actionSyncListObj(TypeAction.LISTAR_OBJ, dispatch, null, customForm.uid));
    }
}

export const getHistorico = (customForm, uidObj,resolve) => (dispatch) => {
    if (customForm.chaveSalvar) {
        // listarObjsRaiz(customForm.chaveSalvar, actionSyncListObj(TypeAction.LISTAR_OBJ, dispatch, null, customForm.chaveSalvar));
         getHistoricoRaiz(customForm.chaveSalvar, uidObj,resolve)
    } else {
        // listarObjs(customForm.uid, userUid(), actionSyncListObj(TypeAction.LISTAR_OBJ, dispatch, null, customForm.uid));
    }
}

export const carregarCustomForm = (uid, retorno) => (dispatch) => {
    if (uid) {
        // carregaCustonForm(uid, actionSyncListObj(TypeAction.CARREGAR_FORM, dispatch, retorno));
    }
}




// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicForms/actions.js